<div>
    <div class="pull-right close" (click)="close()"> &#10005; </div>
    <app-customer-info></app-customer-info>
</div>